var initialState = {
	expandedResponseID: null,
	showPaywall: null,
	editKeys: {}
};

import { EXPAND_RESPONSE, SHOW_PAYWALL, TOGGLE_EDIT } from "lib/actions/UIActions";

function ui(state = initialState, action) {
	switch (action.type) {

	case EXPAND_RESPONSE:
		if (action.expanded) {
			return _.extend({}, state, { expandedResponseID: action.responseID });
		} else {
			return _.extend({}, state, { expandedResponseID: null });
		}

	case SHOW_PAYWALL:
		return _.extend({}, state, { showPaywall: action.paywall });

	case TOGGLE_EDIT:
		if (action.expanded) {
			var editKeys = _.extend({}, state.editKeys, { [action.key]: true });
			return _.extend({}, state, { editKeys: editKeys });
		} else {
			var editKeys = _.omit(state.editKeys, action.key);
			return _.extend({}, state, { editKeys: editKeys });
		}

	default:
		return state
	}
}

module.exports = {
	ui // Interface is a reserved keywork
};


// WEBPACK FOOTER //
// ./modules/lib/reducers/UIReducer.js